var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUndo = function SvgUndo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    id: "undo_svg__Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".undo_svg__cls-1{fill:none;stroke:#292d32;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "undo_svg__rotate-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "undo_svg__Vector",
    className: "undo_svg__cls-1",
    d: "M17.12 13.09c.94-.28 1.91-.43 2.89-.43 4.78 0 8.66 3.89 8.66 8.67 0 4.78-3.89 8.66-8.67 8.66-4.78 0-8.66-3.89-8.66-8.67 0-1.71.51-3.38 1.46-4.81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "undo_svg__Vector-2",
    className: "undo_svg__cls-1",
    d: "m15.88 13.33 2.89-3.32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "undo_svg__Vector-3",
    className: "undo_svg__cls-1",
    d: "m15.88 13.33 3.37 2.46"
  }))));
};
export default SvgUndo;